<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <b-card>
        <div class="table-header-container d-flex justify-content-between align-items-center pt-2 pb-3">
            <div class="title-container d-flex align-items-center">
                <h2 class="pr-1">{{title}}</h2>
                <span>{{rows.length}} დაწესებულება</span>
            </div>

            <b-button variant="secondary" class="">
                <feather-icon icon="PlusIcon"
                              class="mr-50"/>
                <span class="align-middle">ახალი დაწესებულება</span>
            </b-button>
        </div>
        <!-- table -->
        <vue-good-table
                :columns="columns"
                :rows="rows"
                :rtl="direction"
                styleClass="vgt-table condensed">
            <template slot="table-row" slot-scope="props">

                <!-- Column: Name -->
                <span v-if="props.column.field === 'fullName'" class="text-nowrap">
                  <span class="text-nowrap">{{ props.row.fullName }}</span>
                </span>

                <!-- Column: Status -->
                <span v-else-if="props.column.field === 'status'">
                    {{ props.row.status }}
                </span>

                <!-- Column: Action -->
                <span v-else-if="props.column.field === 'action'">
                  <span>
                    <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
                      <template v-slot:button-content>
                        <feather-icon icon="MoreVerticalIcon" size="16" class="text-body align-middle mr-25"/>
                      </template>
                      <b-dropdown-item>
                        <feather-icon icon="Edit2Icon" class="mr-50"/>
                        <span>Edit</span>
                      </b-dropdown-item>
                      <b-dropdown-item>
                        <feather-icon icon="TrashIcon" class="mr-50"/>
                        <span>Delete</span>
                      </b-dropdown-item>
                    </b-dropdown>
                  </span>
                </span>

                <!-- Column: Common -->
                <span v-else>
                  {{ props.formattedRow[props.column.field] }}
                </span>
            </template>

            <!-- pagination -->
            <template
                    slot="pagination-bottom"
                    slot-scope="props"
            >
                <div class="d-flex justify-content-between flex-wrap">
                    <div class="d-flex align-items-center mb-0 mt-1">
            <span class="text-nowrap ">
              Showing 1 to
            </span>
                        <b-form-select
                                v-model="pageLength"
                                :options="['3','5','10']"
                                class="mx-1"
                                @input="(value)=>props.perPageChanged({currentPerPage:value})"
                        />
                        <span class="text-nowrap"> of {{ props.total }} entries </span>
                    </div>
                    <div>
                        <b-pagination
                                :value="1"
                                :total-rows="props.total"
                                :per-page="pageLength"
                                first-number
                                last-number
                                align="right"
                                prev-class="prev-item"
                                next-class="next-item"
                                class="mt-1 mb-0"
                                @input="(value)=>props.pageChanged({currentPage:value})"
                        >
                            <template #prev-text>
                                <feather-icon
                                        icon="ChevronLeftIcon"
                                        size="18"
                                />
                            </template>
                            <template #next-text>
                                <feather-icon
                                        icon="ChevronRightIcon"
                                        size="18"
                                />
                            </template>
                        </b-pagination>
                    </div>
                </div>
            </template>
        </vue-good-table>

    </b-card>
</template>

<script>
    // import BCard from '@core/components/b-card/BCard.vue'
    import {BCard, BPagination, BFormSelect, BDropdown, BDropdownItem, BButton} from "bootstrap-vue"
    import {VueGoodTable} from "vue-good-table"
    import store from "@/store/index"

    export default {
        components: {
            BCard,
            VueGoodTable,
            BPagination,
            BFormSelect,
            BDropdown,
            BDropdownItem,
            BButton
        },
        props: ["rows", "title", "columns"],
        data() {
            return {
                pageLength: 3,
                dir: false,
                columns1: [
                    {
                        label: "Name",
                        field: "fullName",
                    },
                    {
                        label: "Email",
                        field: "email",
                    },
                    {
                        label: "Date",
                        field: "startDate",
                    },
                    {
                        label: "Salary",
                        field: "salary",
                    },
                    {
                        label: "Status",
                        field: "status",
                    },
                    {
                        label: "Action",
                        field: "action",
                    },
                ],
                rowsData: [],
                searchTerm: "",
                status: [{
                    1: "Current",
                    2: "Professional",
                    3: "Rejected",
                    4: "Resigned",
                    5: "Applied",
                },
                    {
                        1: "light-primary",
                        2: "light-success",
                        3: "light-danger",
                        4: "light-warning",
                        5: "light-info",
                    }],
            }
        },
        computed: {
            statusVariant() {
                const statusColor = {
                    /* eslint-disable key-spacing */
                    Current: "light-primary",
                    Professional: "light-success",
                    Rejected: "light-danger",
                    Resigned: "light-warning",
                    Applied: "light-info",
                    /* eslint-enable key-spacing */
                }

                return status => statusColor[status]
            },
            direction() {
                if (store.state.appConfig.isRTL) {
                    // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                    this.dir = true
                    return this.dir
                }
                // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                this.dir = false
                return this.dir
            },
        },
        created() {
            this.$http.get("/good-table/basic")
                .then(res => {
                    this.rowsData = res.data;
                })
        },
    }
</script>

<style lang="scss">
    @import '@core/scss/vue/libs/vue-good-table.scss';
</style>
